module.exports = __webpack_public_path__ + "img/icon-game-7764.a191e931.png";